import { render, staticRenderFns } from "./Instrumente.vue?vue&type=template&id=13864c68"
import script from "./Instrumente.vue?vue&type=script&lang=js"
export * from "./Instrumente.vue?vue&type=script&lang=js"
import style0 from "./Instrumente.vue?vue&type=style&index=0&id=13864c68&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports